import React from 'react';
import { ReactNode } from 'react';
import classNames from 'classnames';

export enum GridType {
  FULL_WIDTH = 'full-width',
  FLUID = 'fluid',
  MAX_WIDTH = 'max-width',
  WEBSITE_WIDTH = 'website-width',
  SMALL_WIDTH = 'small-width',
  MIN_WIDTH = 'min-width',
}

interface GridProps {
  children: ReactNode;
  type: GridType;
  columns?: number;
  extraClass?: string;
}

const typeClassMap: Record<GridProps['type'], string> = {
  'full-width': 'o-container--full-width',
  fluid: 'o-container--fluid',
  'max-width': 'o-container--max-width',
  'website-width': 'o-container--website-width',
  'small-width': 'o-container--small-width',
  'min-width': 'o-container--min-width',
};

const Grid = ({ children, type, columns, extraClass = '' }: GridProps) => {
  if (typeof columns === 'number' && columns > React.Children.count(children)) {
    columns = React.Children.count(children);
  }

  return (
    <section className={`o-container ${typeClassMap[type]}`}>
      <div
        className={classNames(
          'o-max-col-grid',
          typeof columns === 'number' && `o-max-col-grid--${columns}`,
          extraClass
        )}
      >
        {children}
      </div>
    </section>
  );
};

export default Grid;
